import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SantanderGuaranteeIncreaseModalComponent } from './santander-guarantee-increase-modal.component';

@NgModule({
    declarations: [SantanderGuaranteeIncreaseModalComponent],
    imports: [
        CommonModule
    ],
    exports: [SantanderGuaranteeIncreaseModalComponent],
    entryComponents: [SantanderGuaranteeIncreaseModalComponent],
})
export class SantanderGuaranteeIncreaseModalModule { }
